/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VisibilityAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Hide from './Hide/index'
import React from 'react'
import Show from './Show/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VisibilityAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Payabli/Token/VisibilityAction"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Hide'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<button
  data-testid="VisibilityAction.Horizontal"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Show')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'Hide')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Show'))}
 style={{'--mb-1-1I0rmu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-2-1I0rmu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-1I0rmu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'Hide'}>
<Hide
  viewPath={`${viewPath}/Hide`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Show'}>
<Show
  viewPath={`${viewPath}/Show`}
/>
</fromFlow.When>
</button>
{children}
</React.Fragment>)
}